var React = require('react');

function BlogSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.798 0a7.221 7.221 0 00-7.207 7.206 7.13 7.13 0 001.943 4.917L.254 15.4a.867.867 0 000 1.225.872.872 0 001.241 0l3.376-3.379A7.206 7.206 0 108.798 0zm5.456 7.206a5.46 5.46 0 11-5.465-5.472 5.473 5.473 0 015.46 5.472z"}));
}

BlogSearch.defaultProps = {"viewBox":"0 0 16 16.889","aria-hidden":"true"};

module.exports = BlogSearch;

BlogSearch.default = BlogSearch;
